// @flow
import { noop } from 'lodash';
import React, { createContext, FunctionComponent, PropsWithChildren, useCallback, useMemo } from 'react';
import { useSetState } from 'react-use';
import CreateComponentVersionModal from '../components/virtual-component-releases/CreateComponentVersionModal';
import useFlagContext from '../hooks/useFlagContext';

export type ContextType = {
    show: (onSuccessCallback?: Function) => void,
};

export const Context = createContext<ContextType>({
    show: noop,
});

type State = {
    opened?: boolean,
    onSuccess?: Function,
};

const initialState = {
    opened: false,
    onSuccess: null,
};
const ContextProvider: FunctionComponent<PropsWithChildren<unknown>> = ({ children }) => {
    const [{ opened, onSuccess }, setState] = useSetState<State>(initialState);

    const close = useCallback(() => setState(initialState), [setState]);
    const { pushFlag } = useFlagContext();

    const providerValue = useMemo(
        () => ({
            show: (onSuccessCallback) => setState({ opened: true, onSuccess: onSuccessCallback }),
        }),
        [setState],
    );

    return (
        <Context.Provider value={providerValue}>
            {opened && (
                <CreateComponentVersionModal onRefetchRequest={onSuccess} addFlag={pushFlag} onFormClosed={close} />
            )}
            {children}
        </Context.Provider>
    );
};

export const withCreateComponentReleaseContext = (Component) => {
    const WithCreateComponentReleaseContext = (props) => (
        <ContextProvider>
            <Component {...props} />
        </ContextProvider>
    );
    return WithCreateComponentReleaseContext;
};

export default ContextProvider;
